/**
 * Ce fichier permets d'afficher la positions dans la map temps réel
 *
 * © Moustapha HENNAWI - Click and Take off - 2021
 */
/*-------------------------------------------------------------------------------------------*/
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { map } from './Map';
import { selectDevicesArray, selectGroupSelectedId, selectSession } from '../createSelectorUtils';

/*-------------------------------------------------------------------------------------------*/
PositionsMapLive.propTypes = {
  positions: PropTypes.array.isRequired
};

export default function PositionsMapLive({ positions }) {
  const id = 'positionsLive';

  const session = useSelector(selectSession);
  const groupId = useSelector(selectGroupSelectedId);

  const deviceData = useSelector(selectDevicesArray);
  const devices = useMemo(
    () =>
      session.administrator
        ? deviceData
        : deviceData.filter((device) =>
            groupId === 0
              ? device.groupId === 0 ||
                session.permission.find((item) => item.groupid === device.groupId) === undefined
              : device.groupId === groupId
          ),
    [deviceData, groupId, session.administrator, session.permission]
  );

  useEffect(() => {
    map.addSource(id, {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: []
      }
    });
    map.addLayer({
      id,
      type: 'symbol',
      source: id,
      layout: {
        'icon-image': '{category}',
        'icon-rotate': { type: 'identity', property: 'course' },
        'icon-allow-overlap': true,
        'text-field': '{name}',
        'text-allow-overlap': true,
        'text-anchor': 'bottom',
        'text-offset': [0, -2],
        'text-font': ['Roboto Regular'],
        'text-size': 12
      },
      paint: {
        'text-halo-color': 'white',
        'text-halo-width': 1
      }
    });
    return () => {
      if (map.getLayer(id)) {
        map.removeLayer(id);
      }
      if (map.getSource(id)) {
        map.removeSource(id);
      }
    };
  }, []);

  useEffect(() => {
    const createFeature = (device, position) => ({
      deviceId: position.deviceId,
      name: device ? device.name : '',
      category: 'plane',
      course: position.course
    });

    if (map.getSource(id) !== undefined) {
      map.getSource(id).setData({
        type: 'FeatureCollection',
        features: devices.map((device) => {
          const position = positions.find((position) => position.deviceId === device.id);
          if (position && !device.disabled) {
            return {
              type: 'Feature',
              geometry: {
                type: 'Point',
                coordinates: [position.longitude, position.latitude]
              },
              properties: createFeature(device, position)
            };
          }
          return {};
        })
      });
    }
  }, [devices, positions]);

  return null;
}
